import { Box } from '@mui/material';
import { InstanceInputs as Legacy } from './legacy/InstanceInputs';
import { ApplicationDate } from './ApplicationDate';
import { LimeInstanceInputs } from './LimeInstanceInputs';
import { PhosphorusPotassiumInstanceInputs } from './PhosphorusPotassiumInstanceInputs';

export function InstanceInputs({ instance }) {
  const { lime, phosphorus, potassium } = instance.inputs || {};
  const isLegacy = !lime && !phosphorus && !potassium;

  if (isLegacy) return <Legacy instance={instance} />;

  return (
    <Box data-testid="instance-inputs">
      <LimeInstanceInputs inputs={lime} />
      <PhosphorusPotassiumInstanceInputs type="P" inputs={phosphorus} />
      <PhosphorusPotassiumInstanceInputs type="K" inputs={potassium} />
      <ApplicationDate type="L" inputs={lime} />
      <ApplicationDate type="P" inputs={phosphorus} />
      <ApplicationDate type="K" inputs={potassium} />
    </Box>
  );
}
